import { store } from 'src/redux/store';
import { RefreshUserToken, ReAuthoriseUser } from 'src/services/user-http.service';
import { SetUserServiceInfo } from 'src/redux/user/user.actions';
import { getUniversalCookies } from 'src/cookies/cookie';

export const GetToken = async () => {
    const state = store.getState();

    let token = "Bearer " + state.user.userServiceDetails.token;
    let tokenExpiry = state.user.userServiceDetails.tokenExpiry;

    if (tokenExpiry > Date.now()) {
        return token
    } else {
        let email = state.user.userServiceDetails.email;
        let refreshToken = getUniversalCookies().get('RefreshToken');
        let data = await RefreshUserToken(email, refreshToken);

        if (!data.refreshToken) {
            data = await ReAuthoriseUser(email, true);
        }

        data.tokenExpiry = Date.now() + data.tokenExpiry - 5000;
        store.dispatch(SetUserServiceInfo(data));
        getUniversalCookies().set('RefreshToken', data.refreshToken);

        return "Bearer " + data.token
    }
}